var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from 'events';
import { ActionTypes } from 'constants/AdminConstants';
import { FormStateSchema } from 'types/formState';
import { updateFormStateActionSchema } from 'types/actions/formStateActions';
import Dispatcher from '../../dispatcher/Dispatcher';
var CHANGE_EVENT = 'change';
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    function Store() {
        var _this = _super.call(this) || this;
        _this.data = {};
        _this.registerDispatcher();
        return _this;
    }
    Store.prototype.registerDispatcher = function () {
        var _this = this;
        this.dispatchToken = Dispatcher.register(function (action) {
            var formId = action.form_id;
            var isValidFormId = typeof formId === 'number' && formId > 0;
            if (isValidFormId && !_this.data[formId]) {
                _this.data[formId] = {
                    state: FormStateSchema.Enum.INACTIVE,
                    message: '',
                    timer: null
                };
            }
            if (action.type === ActionTypes.UPDATE_FORM_STATE) {
                _this.handleUpdateFormState(action);
            }
        });
    };
    Store.prototype.handleUpdateFormState = function (action) {
        var _a;
        var parsedAction = updateFormStateActionSchema.safeParse(action);
        if (!parsedAction.success) {
            console.error('Invalid action in FormStateStore:', parsedAction.error);
            return;
        }
        var _b = parsedAction.data, formId = _b.form_id, state = _b.state, _c = _b.message, message = _c === void 0 ? '' : _c;
        // Only process if form_id is a valid positive number
        var isValidFormId = typeof formId === 'number' && formId > 0;
        if (!isValidFormId) {
            return;
        }
        var currentFormData = (_a = this.data[formId]) !== null && _a !== void 0 ? _a : {};
        this.data[formId] = __assign(__assign({}, currentFormData), { state: state, message: message });
        this.emitChange();
    };
    Store.prototype.emitChange = function () {
        this.emit(CHANGE_EVENT);
    };
    Store.prototype.addChangeListener = function (callback) {
        this.on(CHANGE_EVENT, callback);
    };
    Store.prototype.removeChangeListener = function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    };
    Store.prototype.getFormState = function (formId) {
        return this.data[formId] || {
            state: FormStateSchema.Enum.INACTIVE,
            message: ''
        };
    };
    return Store;
}(EventEmitter));
var FormStateStore = new Store();
export default FormStateStore;
